import { useLocation } from "react-router-dom";
import SEO from "./SEO";
import SEOConfig from "./SEOConfig";
import { regulations } from "../../constants/regulations";

const FaqSEO = () => {
  const location = useLocation();
  const { siteUrl } = SEOConfig;
  const currentUrl = `${siteUrl}${location.pathname}`;

  const title = "Регламент чемпіонату";
  const description =
    "Ознайомтеся з регламентом та правилами Slick Racing Ukraine. Дізнайтеся про формат чемпіонату, умови участі та інші важливі деталі.";

  // Add relevant keywords for the FAQ/Regulations page
  const keywords = [
    "Slick Racing Ukraine регламент",
    "правила симрейсингу",
    "правила сімрейсінгу",
    "формат чемпіонату",
    "умови участі",
    "iRacing правила",
    "гоночний регламент",
    "спортивний кодекс",
  ];

  // Define breadcrumbs for better navigation and SEO
  const breadcrumbs = [
    {
      name: "Головна",
      url: siteUrl,
    },
    {
      name: "Регламент",
      url: currentUrl,
    },
  ];

  // Describes what the page actually renders: a list of championship
  // regulations, each linking to its published document. Built from the same
  // constant as the page itself so the two cannot drift apart.
  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Регламенти чемпіонатів Slick Racing Ukraine",
    description,
    url: currentUrl,
    numberOfItems: regulations.length,
    itemListElement: regulations.map((regulation, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: regulation.name,
      url: regulation.url,
    })),
  };

  return (
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      url={currentUrl}
      schema={schema}
      canonical={currentUrl}
      type="website"
      breadcrumbs={breadcrumbs}
      lang="uk"
    />
  );
};

export default FaqSEO;
